const PAYMENTS_TRANSITION = 'personalAccident/paystack/payments/';

export const PAYMENTS_SET_VALUE = PAYMENTS_TRANSITION + 'setValue/';
export const PAYMENTS_SET_VALID = PAYMENTS_TRANSITION + 'setValid/';

// Transitions
export const FORM_VALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'validateForm';
export const FORM_INVALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'invalidateForm';

export const validateForm = () => ({ type: FORM_VALIDATE_TRANSITION_PAYMENTS });
export const invalidateForm = () => ({ type: FORM_INVALIDATE_TRANSITION_PAYMENTS });

export const PAYSTACK_CHECK_API_PENDING_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/pending`;
export const PAYSTACK_CHECK_API_SUCCESS_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/success`;
export const PAYSTACK_CHECK_API_FAILURE_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/failure`;
export const PAYSTACK_CHECK_API_INITIAL_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/initialize`;

export const apiTransitionPaystack = {
    pending: () => ({
        type: PAYSTACK_CHECK_API_PENDING_TRANSITION_PAYMENTS_PUSH,
    }),
    success: () => ({
        type: PAYSTACK_CHECK_API_SUCCESS_TRANSITION_PAYMENTS_PUSH,
    }),
    failure: () => ({
        type: PAYSTACK_CHECK_API_FAILURE_TRANSITION_PAYMENTS_PUSH,
    }),
    initialize: () => ({
        type: PAYSTACK_CHECK_API_INITIAL_TRANSITION_PAYMENTS_PUSH,
    }),
};

export const PAYSTACK_CHECK_API_INITIAL_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/paystack/status/initial`;
export const PAYSTACK_CHECK_API_PENDING_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/paystack/status/pending`;
export const PAYSTACK_CHECK_API_SUCCESS_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/paystack/status/success`;
export const PAYSTACK_CHECK_API_FAILURE_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/paystack/status/failure`;

export const apiTransitionPaystackStatus = {
    pending: () => ({
        type: PAYSTACK_CHECK_API_PENDING_TRANSITION_PAYMENTS_STATUS,
    }),
    success: () => ({
        type: PAYSTACK_CHECK_API_SUCCESS_TRANSITION_PAYMENTS_STATUS,
    }),
    failure: () => ({
        type: PAYSTACK_CHECK_API_FAILURE_TRANSITION_PAYMENTS_STATUS,
    }),
    initialize: () => ({
        type: PAYSTACK_CHECK_API_INITIAL_TRANSITION_PAYMENTS_STATUS,
    }),
};

export const TERMS_SET_VALUE = PAYMENTS_SET_VALUE + 'terms';
export const TERMS_SET_VALID = PAYMENTS_SET_VALID + 'terms';

export const setTermsValue = (value) => ({ type: TERMS_SET_VALUE, value });
export const setTermsValid = (error) => ({ type: TERMS_SET_VALID, error });

export const PAYSTACK_CHECK_PAYMENTS_STATUS = PAYMENTS_SET_VALUE + 'checkPaymentsStatus';
export const PAYSTACK_CHECK_PAYMENTS_STATUS_SUCCESS = PAYMENTS_SET_VALUE + 'checkPaymentsStatusSuccess';
export const PAYSTACK_CHECK_PAYMENTS_STATUS_FAILURE = PAYMENTS_SET_VALID + 'checkPaymentsStatusFailure';

export const checkPaymentsStatus = () => ({ type: PAYSTACK_CHECK_PAYMENTS_STATUS });
export const checkPaystackStatusSuccess = (value) => ({ type: PAYSTACK_CHECK_PAYMENTS_STATUS_SUCCESS, value });
export const checkPaystackStatusFailure = (error) => ({ type: PAYSTACK_CHECK_PAYMENTS_STATUS_FAILURE, error });

export const INITIATE_PAYMENT = PAYMENTS_SET_VALUE + 'initiate/paystack/payment';
export const PAYSTACK_PAYMENT_INIT = PAYMENTS_SET_VALUE + 'paystack/payment/init';
export const PAYSTACK_PAYMENT_SUCCESS = PAYMENTS_SET_VALUE + 'paystack/payment/data';
export const PAYSTACK_SUBMIT_PAYMENT = PAYMENTS_SET_VALUE + 'submit/paystack/payment';

export const initiatePayments = () => ({ type: INITIATE_PAYMENT });
export const initPayments = () => ({ type: PAYSTACK_PAYMENT_INIT });
export const submitPaymentSuccess = (value) => ({ type: PAYSTACK_PAYMENT_SUCCESS, value });
export const submitPaystackPayments = () => ({ type: PAYSTACK_SUBMIT_PAYMENT });
